import config from 'config/config'
import { navigationFilter } from 'lib/navigationFilter'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import NavigationButton from './renditions/NavigationButton'
import NavigationCard from './renditions/NavigationCard'
import NavigationCategoriesLevel1 from './renditions/NavigationCategoriesLevel1'
import NavigationColumns from './renditions/NavigationColumns'
import NavigationDropdown from './renditions/NavigationDropdown'
import NavigationItemDropdown from './renditions/NavigationItemDropdown'
import NavigationLink from './renditions/NavigationLink'
import NavigationLinkItem from './renditions/NavigationLinkItem'
import NavigationList from './renditions/NavigationList'
import NavigationMenu from './renditions/NavigationMenu'
import NavigationMenuitem from './renditions/NavigationMenuItem'
import NavigationStep from './renditions/NavigationStep'
import NavigationSubmenu from './renditions/NavigationSubmenu'
import NavigationSubmenuCategories from './renditions/NavigationSubmenuCategories'
import NavigationSubmenuDropdown from './renditions/NavigationSubmenuDropdown'

const mapStateToProps = (state, ownProps) => {
  const { siteMap, language, badges } = state.navigation
  return { siteMap, language, badges }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

class Navigation extends React.Component {
  // TODO: This monster here seems wrong. Except for some base instances,
  // think about just returning the navigation items needed by a reducer call?
  // e ssentially like any other reducer with a filter ...

  static propTypes = {
    // items:  PropTypes.array.isRequired,
    render: PropTypes.oneOf([
      'children',
      'currentTitle',
      'link',
      'siblings',
      'title',
    ]).isRequired,
    as: PropTypes.oneOf([
      'button',
      'card',
      'categories-level1',
      'columns',
      'dropdown',
      'item-dropdown',
      'link',
      'link-item',
      'list',
      'menu',
      'menuitem',
      'menuitem-sidebar',
      'submenu-dropdown',
      'submenu-categories',
      'step',
      'submenu',
      'text',
      'title',
    ]).isRequired,
  }

  render() {
    const dark = config.theme.dark
    const { siteMap, language, badges } = this.props // redux
    const {
      node,
      level,
      location,
      render,
      children,
      as,
      color,
      trigger,
      customProps,
      step,
    } = this.props // ownProps
    const items = navigationFilter(
      siteMap,
      location.pathname,
      render,
      language,
      node,
      parseInt(level, 10),
      badges
    )
    switch (as) {
      case 'button':
        return items.length === 1 ? (
          <NavigationButton
            item={items[0]}
            customProps={customProps}
            children={children}
          />
        ) : (
          false
        )

      case 'card':
        return (
          <NavigationCard
            item={items[0]}
            customProps={customProps}
            children={children}
          />
        )

      case 'categories-level1':
        return <NavigationCategoriesLevel1 items={items} />

      case 'columns':
        return <NavigationColumns items={items} inverted={dark} />

      case 'dropdown':
        return (
          <NavigationDropdown
            color={color}
            items={items}
            customProps={customProps}
          />
        )

      case 'item-dropdown':
        return <NavigationItemDropdown items={items} trigger={trigger} />

      case 'link-item':
        return items.length === 1 ? (
          <NavigationLinkItem item={items[0]} children={children} />
        ) : (
          false
        )

      case 'list':
        return <NavigationList items={items} children={children} />

      case 'menu':
        return <NavigationMenu items={items} color={color} node={node} />

      case 'menuitem':
        return items.length === 1 ? (
          <NavigationMenuitem
            item={items[0]}
            children={children}
            customProps={customProps}
          />
        ) : (
          false
        )

      case 'menuitem-sidebar':
        return items.length === 1 ? (
          <NavigationMenuitem
            item={items[0]}
            children={children}
            customProps={customProps}
            sidebar={true}
          />
        ) : (
          false
        )

      case 'submenu':
        return (
          <NavigationSubmenu
            items={items}
            color={color}
            node={node}
            customProps={customProps}
          />
        )

      case 'submenu-dropdown':
        return (
          <NavigationSubmenuDropdown
            items={items}
            color={color}
            customProps={customProps}
          />
        )

      case 'submenu-categories':
        return (
          <NavigationSubmenuCategories
            items={items}
            color={color}
            node={node}
          />
        )

      case 'step':
        return items.length === 1 ? (
          <NavigationStep
            item={items[0]}
            customProps={customProps}
            step={step}
            children={children}
          />
        ) : (
          false
        )

      case 'text':
        return items.length === 1 ? <div>{items[0].content}</div> : false

      default:
      case 'link':
        return items.length === 1 ? (
          <NavigationLink item={items[0]} children={children} />
        ) : (
          false
        )
    }
  }
}

Navigation = connect(mapStateToProps, mapDispatchToProps)(Navigation)
export default withRouter(Navigation)



// WEBPACK FOOTER //
// ./src/components/shared/Navigation/Navigation.jsx